import Api from '@/services/api';
//import qs from 'querystring';

export default {

  list() {
    return Api().get('/codas/list');
  },
  import(data) {
    return Api().post('/codas/import', 'process=' + encodeURIComponent(JSON.stringify(data)))
  }
}